import { getUser } from '@app/auth/redux/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

function AuthFree() {
  const user = useSelector(getUser);
  const token = localStorage.getItem('x-access-token');
  if (user.account_verified && token) {
    return (
      <div>
        <Redirect to="/baskets" />
      </div>
    );
  } else {
    return <div style={{ display: 'none' }}></div>;
  }
}

export default AuthFree;
